(function (angular) {
  "use strict";

  angular.module("app").service("EmailTemplatesApi", emailTemplatesApi);

  emailTemplatesApi.$inject = ["$resource", "settings", "extendResource"];

  function emailTemplatesApi($resource, settings, extendResource) {
    var resource = $resource(
      settings.apiBase + "/email-templates/:etKey",
      { etKey: "@etKey" },
      {
        update: {
          method: "PUT",
        },
      },
    );

    return extendResource(resource);
  }
})(angular);
